export const GET_SUPER_CORPORATE = "GET_SUPER_CORPORATE";
export const GET_SUPER_VAT_ACCOUNT = "GET_SUPER_VAT_ACCOUNT";
export const GET_SUPER_VAT_ACCOUNTS = "GET_SUPER_VAT_ACCOUNTS";
export const GET_SUPER_COMMERCIAL_ACCOUNTS = "GET_SUPER_COMMERCIAL_ACCOUNTS";
export const GET_SUPER_COMMERCIAL_ACCOUNT = "GET_SUPER_COMMERCIAL_ACCOUNT";
export const GET_CURRENT_SUPPER_COPROATE_ID = "GET_CURRENT_SUPPER_COPROATE_ID";
